import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-zh",
  "use": "icon-zh-usage",
  "viewBox": "0 0 23 23",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 23 23\" id=\"icon-zh\"><path d=\"M22.114 0H4.43a.898.898 0 0 0-.886.886c0 .48.406.886.886.886h16.798v16.872c0 .48.406.886.886.886s.886-.406.886-.886V.886A.898.898 0 0 0 22.114 0z\" /><path d=\"M18 3a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h16zm-7.314 3.464H9.314v2.422h-4.97v6.762h1.33v-.798h3.64v4.69h1.372v-4.69h3.654v.798h1.33V8.886h-4.984V6.464zm-1.372 3.724v3.36h-3.64v-3.36h3.64zm5.026 0v3.36h-3.654v-3.36h3.654z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol